import { LoanProduct } from '../../generated-types';

export interface LoanProductRegValid {
    expression: RegExp;
    min: number;
    max: number;
}

export default function LoanProductRegValidations(loanProduct: LoanProduct): LoanProductRegValid {
    switch (loanProduct) {
        case 'CAR':
        case 'CAR_ZERO_EMISSION':
        case 'CAMPING_CAR':
            return {
                expression: /^[a-zA-Z]{2}[0-9]{5}/,
                min: 7,
                max: 7,
            };
        case 'ATV':
        case 'MC':
        case 'SNOWMOBILE':
        case 'CARAVAN':
            return {
                expression: /^[a-zA-Z]{2}[0-9]{4}/,
                min: 6,
                max: 6,
            };
        case 'CAR_NO_INSURANCE':
            return {
                expression: /^[a-zA-Z]{1,2}[0-9]{3,5}/,
                min: 4,
                max: 7,
            };
        default:
            return {
                expression: /^[a-zA-Z]{2}[0-9]{5}/,
                min: 7,
                max: 7,
            };
    }
}
